import { formatDate } from "@on-site/utils/date";
import type { EventCardProps } from "./type";
import { Typography } from "@fanka/ui-admin";
import { parseToString } from "@on-site/utils/parse";
import { DATE_FORMAT } from "@on-site/constants/date";

export const EventCard = ({ event: { medicalMenu, department, date } }: EventCardProps) => (
  <div className="bg-ui-white text-ui-500 w-full px-4">
    <div className="border-brand-beige flex flex-col items-center gap-2 border-b py-4">
      <Typography.UiText size="lg" bold>
        {formatDate(date, DATE_FORMAT.yyyyMdE_jp)}
      </Typography.UiText>
      <div className="flex items-baseline gap-2">
        <Typography.Heading type="h1">{`${formatDate(date, DATE_FORMAT.HHmm)}~`}</Typography.Heading>
        {!!medicalMenu.displayDuration && (
          <Typography.UiText size="md" bold>{`[所要${medicalMenu.displayDuration}分]`}</Typography.UiText>
        )}
      </div>
    </div>

    <div className="flex flex-col items-center gap-2 py-4">
      <Typography.Heading type="h2">{parseToString(department.name, "")}</Typography.Heading>
      <Typography.UiText size="md" bold>
        {medicalMenu.displayName}
      </Typography.UiText>
    </div>
  </div>
);
